import { useNavigate } from 'react-router';
import { Tabs } from '../../ds/components';
import styles from './figures/figures.module.css';

/** Tabs row of the controlling module (D-324): „Kennzahlen" (`/controlling`) and „Vertrieb" (`/controlling/sales`). */

export type ControllingTab = 'figures' | 'sales';

export const CONTROLLING_TABS: readonly { value: ControllingTab; label: string; href: string }[] = [
  { value: 'figures', label: 'Kennzahlen', href: '/controlling' },
  { value: 'sales', label: 'Vertrieb', href: '/controlling/sales' },
];

export function ControllingTabs({ tab }: { tab: ControllingTab }) {
  const navigate = useNavigate();
  return (
    <Tabs
      label="Controlling"
      className={styles.tabs}
      items={CONTROLLING_TABS.map(({ value, label }) => ({ value, label }))}
      value={tab}
      onChange={(value) => {
        const target = CONTROLLING_TABS.find((item) => item.value === value);
        if (target && value !== tab) void navigate(target.href);
      }}
    />
  );
}
